class VariantRadios extends HTMLElement {
	constructor() {
		super()

		this.initListeners()
	}

	initListeners() {
		this.addEventListener("change", this.onVariantChange)
		window.addEventListener("product-form-update", this.onCartQuantityChange.bind(this))
		window.addEventListener("DOMContentLoaded", this.onVariantLoad.bind(this))
	}

	async onVariantLoad() {
		this.updateOptions()
		this.getVariantData()
		this.updateDisabledOptions()
	}

	async onVariantChange() {
		this.updateOptions()
		this.updateMasterId()
		this.updateURL()
		await this.renderProductInfo()
		this.triggerProductGalleryUpdate()
		this.updateDisabledOptions()
	}

	async onCartQuantityChange() {
		this.updateOptions()
		this.updateMasterId()
		this.updateURL()
		await this.renderProductInfoForm()
		this.updateDisabledOptions()
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"))
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value
		})
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options.map((option, index) => {
				return this.options[index] === option
			}).includes(false)
		})

	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === "false") return
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
	}

	async makeRequest() {
		const response = await fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
		return new DOMParser().parseFromString(await response.text(), "text/html")
	}

	async renderProductInfo() {
		const productInfo = document.querySelector(".product-options_info-inner")
		this.initLoader(productInfo)

		const html = await this.makeRequest()

		this.renderElement(".product-options_info", html)
		this.renderElement(".product-options_options-info", html)
		this.renderElement(".product-form", html)
	}

	async renderProductInfoForm() {
		const html = await this.makeRequest()
		this.renderElement(".product-form_form", html)
	}

	renderElement(selector, html) {
		const destination = document.querySelector(selector)
		const source = html.querySelector(selector)

		if (destination && source) {
			destination.innerHTML = source.innerHTML
		}
	}

	initLoader(target) {
		target.innerHTML = "<div class='loader'><span class='loader_dot'></span><span class='loader_dot'></span><span class='loader_dot'></span></div>"
	}

	getVariantData() {
		this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent)
		return this.variantData
	}

	triggerProductGalleryUpdate() {
		const productGalleryUpdateTrigger = new CustomEvent("product-gallery-update")
		window.dispatchEvent(productGalleryUpdateTrigger)
	}

	updateDisabledOptions() {
		const variants_available_arr = this.variantData.map(item => item.available);
		const variants_options = [
				this.variantData.map(item => item.option1),
				this.variantData.map(item => item.option2),
				this.variantData.map(item => item.option3)
		];

		const fieldsets = this.querySelectorAll("fieldset");

		fieldsets.forEach((fieldset, index) => {
				const options = fieldset.querySelectorAll("input");
				options.forEach((input) => {
						let option_disabled = true;

						this.variantData.forEach((variant, variantIndex) => {
								let matchesAllSelected = true;

								// Check if this option matches all selected options (except the current one)
								this.options.forEach((selectedOption, optionIndex) => {
										if (optionIndex !== index && selectedOption !== null && selectedOption !== variant.options[optionIndex]) {
												matchesAllSelected = false;
										}
								});

								// If the option is available and fits the selected options
								if (matchesAllSelected && variant.options[index] === input.value && variant.available) {
										option_disabled = false;
								}
						});

						if (option_disabled) {
								input.classList.add("disabled");
						} else {
								input.classList.remove("disabled");
						}
				});
		});
}

}

customElements.define("variant-radios", VariantRadios)
